import { render, staticRenderFns } from "./file.vue?vue&type=template&id=03b2f066&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=03b2f066&prod&lang=stylus"
import style1 from "./file.vue?vue&type=style&index=1&id=03b2f066&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b2f066",
  null
  
)

export default component.exports